/** Stable mutation key factories — must match setMutationDefaults registration. */

export const mutationKeys = {
  sendDmMessage: (userId, otherUserId) => [
    'mutations',
    'messages',
    'send',
    'dm',
    userId,
    otherUserId,
  ],

  sendGroupMessage: (groupId) => ['mutations', 'messages', 'send', 'group', groupId],

  rsvpWrite: (userId) => ['mutations', 'rsvp', userId],

  groupMembership: (userId) => ['mutations', 'groupMembership', userId],

  followWrite: (userId) => ['mutations', 'follow', userId],
};

export function dmMessageScopeId(userId, otherUserId) {
  const pair = [String(userId), String(otherUserId)].sort();
  return `dm-messages-${pair[0]}-${pair[1]}`;
}

export function groupMessageScopeId(groupId) {
  return `group-messages-${groupId}`;
}
